export const TRANSITION = {
  DEFAULT: {
    duration: 0.25,
    ease: 'easeInOut',
    delay: 0,
  },
  APPEARING_UPWARD: {
    duration: 0.5,
    ease: 'easeInOut',
    delay: 0,
    // repeat: Infinity, // for testing
  },
  APPEARING_EXPAND: {
    duration: 0.5,
    ease: 'easeIn',
    delay: 0,
    // repeat: Infinity, // for testing
  },
}
